import { render, staticRenderFns } from "./wifi.vue?vue&type=template&id=f5252e48"
import script from "./wifi.vue?vue&type=script&lang=js"
export * from "./wifi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports